var _path, _path2, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.161.509h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.086 14.864-1.318-2.806a1.891 1.891 0 0 0-1.712-1.087h-6.167c-.733 0-1.4.423-1.711 1.087l-1.319 2.806H8.667a1.892 1.892 0 0 0-1.891 1.892v23.4c0 1.044.847 1.891 1.891 1.891h34.987a1.891 1.891 0 0 0 1.891-1.891v-23.4a1.892 1.892 0 0 0-1.891-1.892H32.086Z",
    style: {
      fill: "#b73c3c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.086 12.864-1.318-2.806a1.891 1.891 0 0 0-1.712-1.087h-6.167c-.733 0-1.4.423-1.711 1.087l-1.319 2.806H6.667a1.892 1.892 0 0 0-1.891 1.892v23.4c0 1.044.847 1.891 1.891 1.891h34.987a1.891 1.891 0 0 0 1.891-1.891v-23.4a1.892 1.892 0 0 0-1.891-1.892H30.086Zm-1.201 1.892-1.829-3.894h-6.167l-1.829 3.894H6.667v23.4h34.987v-23.4H28.885Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.099 13.797-1.912-4.068h-6.446l-1.912 4.068H5.877v25.491h36.567V13.797H29.099Z",
    style: {
      fill: "#fff261"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b73c3c"
    },
    d: "M34.272 16.088h6.455v2.259h-6.455z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 23.699h36.536v4.389H5.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24.408,
    cy: 27.626,
    r: 7.5,
    style: {
      fill: "#fff261"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.408 18.234c-5.183 0-9.391 4.208-9.391 9.392 0 5.183 4.208 9.391 9.391 9.391s9.391-4.208 9.391-9.391c0-5.184-4.208-9.392-9.391-9.392Zm0 1.892c4.14 0 7.5 3.36 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.14 3.361-7.5 7.5-7.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.321,
    cy: 27.626,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.442,
    cy: 17.652,
    r: 1.82
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.15b0a0134238a7d8990930760559c94e.svg";
export { ForwardRef as ReactComponent };